/**
 * AudioBookPageV2 — redesigned Audiobooks list shell, port of the
 * prototype's `.screen-audiobooks` page-head (cms-redesign-mockup.html
 * ~line 6155–6166).
 *
 * Three header pieces:
 *   • Eyebrow "Content Library" + title "Audiobooks {N items}"
 *   • Sub copy describing the data model (subcategories with is_book=1)
 *   • Two actions: "Manage category →" (links into the 📚 Audiobooks
 *     category edit page, same hardcoded category_id=32 as v1) and
 *     "+ New Audiobook" (coral, links to /audiobooks/add)
 *
 * The list body (AudiobookTableV2) hosts its own toolbar (status
 * filter + Cards/Table view toggle), so we keep the PageHeader lean.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AudiobookTableV2 from '../../AudiobookTable/v2/AudiobookTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function AudioBookPageV2() {
  // Count for the header chip — derived from the same reducer slice
  // the table component reads from, scoped to is_book rows.
  const total = useSelector((s) => {
    const map = s.subcategories.subcategories;
    if (!map) return undefined;
    return Object.values(map).filter((x) => x.subcategory_is_book).length;
  });
  const totalLabel = total != null ? `${total.toLocaleString()} items` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Library"
        title="Audiobooks"
        total={totalLabel}
        actions={
          <>
            <Link
              to="/category/edit/32?from=audiobooks"
              className="no-underline"
            >
              <Button variant="default" trailingIcon={<span aria-hidden>→</span>}>
                Manage category
              </Button>
            </Link>
            <Link to="/audiobooks/add" className="no-underline">
              <Button variant="coral" leadingIcon={PlusSign}>
                New Audiobook
              </Button>
            </Link>
          </>
        }
      />
      <AudiobookTableV2 />
    </div>
  );
}
